module.exports = ".content{\n    text-align: center;\n}\n\n.error{\n    color: red;\n}\n\n.message {\n    color:blue;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/agent/agent-dashboard/billing-sync/billing-sync-component.css
// module id = ./src/app/agent/agent-dashboard/billing-sync/billing-sync-component.css
// module chunks = main